"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[5047],{

/***/ 5649:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   cV: () => (/* binding */ getAnalyticsContext),
/* harmony export */   yT: () => (/* binding */ updateAnalyticsContext)
/* harmony export */ });
/* unused harmony export setAnalyticsContext */
// Global context for analytics events
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
var globalContext = {};
var setAnalyticsContext = function(context) {
    globalContext = context;
};
var updateAnalyticsContext = function(context) {
    globalContext = _object_spread({}, globalContext, context);
};
var getAnalyticsContext = function() {
    return globalContext;
};


/***/ }),

/***/ 85434:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85183);
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var logger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58738);
/* harmony import */ var _wrapper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15894);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}



var dataLayer = (0,_wrapper__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    entityKey: "dataLayer",
    resolveMethods: {
        track: function(event, params) {
            logger__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z.info({
                params: params
            }, "[DataLayer] track %s", event);
            try {
                window.dataLayer.push(_object_spread({
                    event: event
                }, params));
            } catch (error) {
                logger__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z.warn(error);
            }
        },
        push: function(params) {
            window.dataLayer.push(params);
        }
    }
});
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (dataLayer);


/***/ }),

/***/ 66226:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Cn: () => (/* binding */ trackOnce),
/* harmony export */   j: () => (/* binding */ track)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_date_to_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45942);
/* harmony import */ var core_js_modules_es_date_to_string_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_date_to_string_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_date_now_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25503);
/* harmony import */ var core_js_modules_es_date_now_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_date_now_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43474);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_test_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46781);
/* harmony import */ var core_js_modules_es_regexp_test_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_test_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17376);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35570);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_set_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41964);
/* harmony import */ var core_js_modules_es_set_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5119);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(94218);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(40045);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(51497);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var local_storage__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(55222);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(50556);
/* harmony import */ var _mixpanel__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(94064);
/* harmony import */ var _snowplow__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(49594);
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_array(arr) {
    return _array_with_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}















var pageEventSessionTime = 30 * 60 * 1000 // 30 minutes
;
var isPageEventSessionActive = function() {
    var nowTime = Date.now();
    var lastPageEventTime = local_storage__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z.getItem(helpers__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z.localStorageNames.lastAnalyticsPageEventTime);
    var timeDiff = lastPageEventTime ? nowTime - lastPageEventTime : 0;
    return !lastPageEventTime || timeDiff > pageEventSessionTime;
};
var updatePageEventSessionActivity = function() {
    local_storage__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z.setItem(helpers__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z.localStorageNames.lastAnalyticsPageEventTime, Date.now());
};
var track = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _mixpanel, _snowplow;
    var _args = _to_array(args), eventName = _args[0], trackArgs = _args.slice(1);
    var isPageEvent = /\spage$/.test(eventName);
    if (isPageEvent) {
        var isEntryPoint = isPageEventSessionActive();
        if (isEntryPoint) {
            trackArgs[0] = _object_spread_props(_object_spread({}, trackArgs[0]), {
                isEntryPoint: true
            });
        }
        updatePageEventSessionActivity();
    }
    (_mixpanel = _mixpanel__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z).track.apply(_mixpanel, [
        eventName
    ].concat(_to_consumable_array(trackArgs)));
    (_snowplow = _snowplow__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z).track.apply(_snowplow, [
        eventName
    ].concat(_to_consumable_array(trackArgs)));
};
var trackedEvents = new Set();
// track event only one per session
var trackOnce = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _args = _sliced_to_array(args, 1), eventName = _args[0];
    if (trackedEvents.has(eventName)) {
        return;
    }
    trackedEvents.add(eventName);
    track.apply(void 0, _to_consumable_array(args));
};







/***/ }),

/***/ 94064:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var logger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58738);
/* harmony import */ var _wrapper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15894);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5649);
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}



var mixpanel = (0,_wrapper__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    entityKey: "mixpanel",
    // wait for mixpanel initialization. get_distinct_id is available only when mixpanel is initialized
    entityResolver: function() {
        var _window_mixpanel;
        return typeof ((_window_mixpanel = window.mixpanel) === null || _window_mixpanel === void 0 ? void 0 : _window_mixpanel.get_distinct_id) === "function";
    },
    resolveMethods: {
        onInit: function(cb) {
            return cb();
        },
        track: function(eventName, eventProperties) {
            var _getAnalyticsContext = (0,_context__WEBPACK_IMPORTED_MODULE_1__/* .getAnalyticsContext */ .cV)(), page = _getAnalyticsContext.page, pageType = _getAnalyticsContext.pageType;
            var properties = _object_spread({
                page: page,
                pageType: pageType
            }, eventProperties);
            logger__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z.info({
                properties: properties
            }, "[Mixpanel] track %s", eventName);
            // ATTN if you need callback argument, create a new type for tracking function
            window.mixpanel.track(eventName, properties);
        },
        getDistinctId: function() {
            return window.mixpanel.get_distinct_id();
        },
        identify: true,
        unregister: true,
        register: true,
        reset: true,
        peopleSet: function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _window_mixpanel_people;
            (_window_mixpanel_people = window.mixpanel.people).set.apply(_window_mixpanel_people, _to_consumable_array(args));
        },
        peopleSetOnce: function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _window_mixpanel_people;
            (_window_mixpanel_people = window.mixpanel.people).set_once.apply(_window_mixpanel_people, _to_consumable_array(args));
        }
    }
});
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (mixpanel);


/***/ }),

/***/ 49594:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_json_stringify_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76189);
/* harmony import */ var core_js_modules_es_json_stringify_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_json_stringify_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var logger__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58738);
/* harmony import */ var _wrapper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15894);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5649);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}




var snowplow = (0,_wrapper__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    entityKey: "snowplow",
    resolveMethods: {
        setUserId: function(userId) {
            window.snowplow("setUserId", userId);
        },
        trackPageView: function(pathname, params) {
            var properties = _object_spread({}, (0,_context__WEBPACK_IMPORTED_MODULE_2__/* .getAnalyticsContext */ .cV)(), params);
            logger__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z.info({
                pathname: pathname,
                properties: properties
            }, "[Snowplow] trackPageView");
            window.snowplow("trackPageView", {
                title: pathname,
                context: [
                    {
                        // https://github.com/scentbird/event-processor/blob/master/snowplow/IgluCentral/schemas/com.scentbird/pageviews/jsonschema/1-0-0
                        schema: "iglu:com.scentbird/pageviews/jsonschema/1-0-0",
                        data: properties
                    }
                ]
            });
        },
        track: function(eventName, params) {
            var properties = _object_spread({}, (0,_context__WEBPACK_IMPORTED_MODULE_2__/* .getAnalyticsContext */ .cV)(), params);
            logger__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z.info({
                properties: properties
            }, "[Snowplow] track %s", eventName);
            window.snowplow("trackSelfDescribingEvent", {
                event: {
                    schema: "iglu:com.scentbird/freestyle/jsonschema/1-0-0",
                    data: {
                        eventName: eventName,
                        properties: JSON.stringify(properties)
                    }
                }
            });
        }
    }
});
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (snowplow);


/***/ }),

/***/ 15894:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ wrapper)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/web.timers.js
var web_timers = __webpack_require__(73598);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__(57890);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__(96837);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(51497);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(85183);
// EXTERNAL MODULE: ./local_modules/cookie-storage/index.ts + 2 modules
var cookie_storage = __webpack_require__(83913);
// EXTERNAL MODULE: ./local_modules/logger/index.ts
var logger = __webpack_require__(58738);
;// CONCATENATED MODULE: ./local_modules/analytics/wrapper/eventsSaver.ts
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


var eventsSaver = function(entityKey) {
    var events = [];
    var entity = {
        events: events,
        callback: null,
        watching: false
    };
    if (window.eventsSaver) {
        window.eventsSaver[entityKey] = entity;
    } else {
        window.eventsSaver = _define_property({}, entityKey, entity);
    }
    return function(event) {
        try {
            var _ref = window.eventsSaver[entityKey] || {}, watching = _ref.watching, callback = _ref.callback;
            if (watching) {
                events.push(event);
            }
            if (typeof callback === "function") {
                callback(event);
            }
        } catch (error) {
            logger/* default */.Z.error(error);
        }
    };
};
/* harmony default export */ const wrapper_eventsSaver = (eventsSaver);

;// CONCATENATED MODULE: ./local_modules/analytics/wrapper/analyticsWrapper.ts
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}








var areEventsDisabled =  false || cookie_storage/* default */.ZP.getItem("noAnalytics");
var analyticsWrapper = function(options) {
    if (false) {}
    var entityKey = options.entityKey, entityResolver = options.entityResolver, resolveMethods = options.resolveMethods;
    var eventsSaver = wrapper_eventsSaver(entityKey);
    var resolver = entityResolver || function() {
        return Boolean(window[entityKey]);
    };
    var isEntityResolved = resolver();
    var entityResolveTimer;
    var waitList = [];
    if (!isEntityResolved) {
        entityResolveTimer = setInterval(function() {
            var isEntityResolvedNow = resolver();
            if (isEntityResolvedNow) {
                clearInterval(entityResolveTimer);
                entityResolveTimer = null;
                isEntityResolved = true;
                while(waitList.length > 0){
                    var resolveMethod = waitList.shift();
                    resolveMethod();
                }
            }
        }, 250);
        setTimeout(function() {
            if (entityResolveTimer) {
                clearInterval(entityResolveTimer);
                entityResolveTimer = null;
                logger/* default */.Z.warn("%s initialization failed", entityKey);
            }
        }, 20000);
    }
    return Object.keys(resolveMethods).reduce(function(acc, methodName) {
        var resolveMethod = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            eventsSaver({
                methodName: methodName,
                data: args
            });
            if (areEventsDisabled) {
                return;
            }
            try {
                var _resolveMethods;
                if (resolveMethods[methodName] === true) {
                    var _window_entityKey;
                    return (_window_entityKey = window[entityKey])[methodName].apply(_window_entityKey, _to_consumable_array(args));
                }
                return (_resolveMethods = resolveMethods)[methodName].apply(_resolveMethods, _to_consumable_array(args));
            } catch (error) {
                logger/* default */.Z.warn(error);
            }
        };
        acc[methodName] = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (isEntityResolved) {
                return resolveMethod.apply(void 0, _to_consumable_array(args));
            } else {
                waitList.push(function() {
                    return resolveMethod.apply(void 0, _to_consumable_array(args));
                });
            }
        };
        return acc;
    }, {});
};
/* harmony default export */ const wrapper_analyticsWrapper = (analyticsWrapper);

;// CONCATENATED MODULE: ./local_modules/analytics/wrapper/index.ts

/* harmony default export */ const wrapper = (wrapper_analyticsWrapper);


/***/ }),

/***/ 83913:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  ZP: () => (/* binding */ cookie_storage)
});

// UNUSED EXPORTS: CookieStorage, getSiteNoneCompatible

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__(57890);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__(96837);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(51497);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__(62100);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__(69453);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(85183);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(35570);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__(8946);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__(6135);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(28950);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.error.cause.js
var es_error_cause = __webpack_require__(68471);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.error.to-string.js
var es_error_to_string = __webpack_require__(86011);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.is-array.js
var es_array_is_array = __webpack_require__(75983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__(83464);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.json.stringify.js
var es_json_stringify = __webpack_require__(76189);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.date.to-string.js
var es_date_to_string = __webpack_require__(45942);
// EXTERNAL MODULE: ../../node_modules/.pnpm/cookie@0.6.0/node_modules/cookie/index.js
var cookie = __webpack_require__(15679);
// EXTERNAL MODULE: ./local_modules/logger/index.ts
var logger = __webpack_require__(58738);
;// CONCATENATED MODULE: ./local_modules/cookie-storage/CookieStorage.ts
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


















var BACKEND_BLACK_LIST_COOKIES = (/* unused pure expression or super */ null && ([
    "test_abTests",
    "test_abTests.sig",
    "test_features",
    "test_features.sig"
]));
var CookieStorage = /*#__PURE__*/ function() {
    "use strict";
    function CookieStorage(options) {
        var _this = this;
        _class_call_check(this, CookieStorage);
        _define_property(this, "isSiteNoneCompatible", void 0);
        _define_property(this, "isSecure", void 0);
        _define_property(this, "request", void 0);
        _define_property(this, "response", void 0);
        _define_property(this, "serverCookieCache", null);
        // prepare cookie header string for api call
        _define_property(this, "getForRequest", function() {
            if (false) { var cookies; }
            return "";
        });
        // set cookies from set-cookie header from api call
        _define_property(this, "setFromResponse", function(headers) {
            if (false) { var newCookies, splitCookieHeaders, setCookieParser; }
        });
        var _options_isSiteNoneCompatible = options.isSiteNoneCompatible, isSiteNoneCompatible = _options_isSiteNoneCompatible === void 0 ? true : _options_isSiteNoneCompatible, _options_isSecure = options.isSecure, isSecure = _options_isSecure === void 0 ? false : _options_isSecure, request = options.request, response = options.response;
        this.isSiteNoneCompatible = isSiteNoneCompatible;
        this.isSecure = isSecure;
        this.request = request;
        this.response = response;
    }
    _create_class(CookieStorage, [
        {
            key: "getCookies",
            value: function getCookies() {
                if (false) {} else {
                    // we should read client cookie every time
                    return (0,cookie/* parse */.Q)(document.cookie || "");
                }
            }
        },
        {
            key: "getResponseHeaders",
            value: function getResponseHeaders() {
                var headers = this.response.getHeader("Set-Cookie");
                if (Array.isArray(headers)) {
                    return headers;
                }
                if (typeof headers === "string") {
                    return [
                        headers
                    ];
                }
                return [];
            }
        },
        {
            key: "updateResponseHeader",
            value: function updateResponseHeader(updatedHeaders) {
                var newHeaders = this.getResponseHeaders().filter(function(value) {
                    // remove for existing headers duplicated values
                    return !updatedHeaders.includes(value);
                }).concat(updatedHeaders);
                if (this.response.headersSent) {
                    return;
                }
                this.response.setHeader("Set-Cookie", newHeaders);
            }
        },
        {
            key: "getItem",
            value: function getItem(name, attributes) {
                // logger.debug(`Get cookie ${name}`)
                var _ref = attributes || {}, _ref_json = _ref.json, json = _ref_json === void 0 ? true : _ref_json;
                var cookies = this.getCookies();
                var value = cookies[name];
                if (json) {
                    try {
                        return JSON.parse(value);
                    } catch (error) {
                        // @ts-ignore
                        return value;
                    }
                }
                // @ts-ignore
                return value;
            }
        },
        {
            key: "setItem",
            value: function setItem(name, value, attributes) {
                var _ref = attributes || {}, _ref_json = _ref.json, json = _ref_json === void 0 ? true : _ref_json, restAttributes = _object_without_properties(_ref, [
                    "json"
                ]);
                var cookieValue = json && typeof value === "object" ? JSON.stringify(value) : String(value);
                // check sameSite compatibility
                if (restAttributes.sameSite === "None" && !this.isSiteNoneCompatible) {
                    delete restAttributes.sameSite;
                }
                var cookieAttributes = _object_spread({
                    maxAge: 365 * 24 * 60 * 60,
                    secure: this.isSecure,
                    httpOnly: false,
                    sameSite: "Lax",
                    path: "/"
                }, restAttributes);
                var cookieHeader;
                try {
                    cookieHeader = (0,cookie/* serialize */.q)(name, cookieValue, cookieAttributes);
                } catch (error) {
                    logger/* default */.Z.error({
                        error: error,
                        name: name,
                        cookieAttributes: cookieAttributes
                    });
                    return;
                }
                logger/* default */.Z.debug("[Cookie] %s %s", cookieAttributes.maxAge === -1 || cookieValue === "" ? "remove" : "set", name);
                if (false) {} else {
                    document.cookie = cookieHeader;
                }
            }
        },
        {
            key: "setSessionItem",
            value: function setSessionItem(name, value, attributes) {
                this.setItem(name, value, _object_spread_props(_object_spread({}, attributes), {
                    expires: null,
                    maxAge: null
                }));
            }
        },
        {
            key: "removeItem",
            value: function removeItem(name, attributes) {
                this.setItem(name, "", _object_spread_props(_object_spread({}, attributes), {
                    expires: new Date(0),
                    maxAge: 0
                }));
            }
        }
    ]);
    return CookieStorage;
}();
/* harmony default export */ const cookie_storage_CookieStorage = (CookieStorage);

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.parse-int.js
var es_parse_int = __webpack_require__(21402);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.string.match.js
var es_string_match = __webpack_require__(73281);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(17376);
;// CONCATENATED MODULE: ./local_modules/cookie-storage/getSiteNoneCompatible.ts



var intToString = function(intValue) {
    return String(intValue);
};
var stringToInt = function(strValue) {
    return parseInt(strValue, 10) || 0;
};
var regexContains = function(stringValue, regex) {
    var matches = stringValue.match(regex);
    return matches !== null;
};
var isSafari = function(useragent) {
    var safari_regex = /Version\/.* Safari\//;
    return useragent.match(safari_regex) !== null && !isChromiumBased(useragent);
};
var extractRegexMatch = function(stringValue, regex, offsetIndex) {
    var matches = stringValue.match(regex);
    if ((matches === null || matches === void 0 ? void 0 : matches[offsetIndex]) !== undefined) {
        return matches[offsetIndex];
    }
    return null;
};
var isIosVersion = function(major, useragent) {
    var regex = /\(iP.+; CPU .*OS (\d+)[_\d]*.*\) AppleWebKit\//;
    return extractRegexMatch(useragent, regex, 1) === intToString(major);
};
var isMacosxVersion = function(major, minor, useragent) {
    var regex = /\(Macintosh;.*Mac OS X (\d+)_(\d+)[_\d]*.*\) AppleWebKit\//;
    return extractRegexMatch(useragent, regex, 1) === intToString(major) && extractRegexMatch(useragent, regex, 2) === intToString(minor);
};
var isMacEmbeddedBrowser = function(useragent) {
    var regex = /^Mozilla\/[\.\d]+ \(Macintosh;.*Mac OS X [_\d]+\) AppleWebKit\/[\.\d]+ \(KHTML, like Gecko\)$/;
    return regexContains(useragent, regex);
};
var isChromiumBased = function(useragent) {
    var regex = /Chrom(e|ium)/;
    return regexContains(useragent, regex);
};
var isChromiumVersionAtLeast = function(major, useragent) {
    var regex = /Chrom[^ \/]+\/(\d+)[\.\d]* /;
    var version = stringToInt(extractRegexMatch(useragent, regex, 1));
    return version >= major;
};
var isUcBrowser = function(useragent) {
    var regex = /UCBrowser\//;
    return regexContains(useragent, regex);
};
var dropsUnrecognizedSameSiteCookies = function(useragent) {
    return isChromiumBased(useragent) && isChromiumVersionAtLeast(51, useragent) && !isChromiumVersionAtLeast(67, useragent) || isUcBrowser(useragent) && !isUcBrowserVersionAtLeast(12, 13, 2, useragent);
};
var hasWebKitSameSiteBug = function(useragent) {
    return isIosVersion(12, useragent) || isMacosxVersion(10, 14, useragent) && (isSafari(useragent) || isMacEmbeddedBrowser(useragent));
};
var isSameSiteNoneIncompatible = function(useragent) {
    return hasWebKitSameSiteBug(useragent) || dropsUnrecognizedSameSiteCookies(useragent);
};
var isUcBrowserVersionAtLeast = function(major, minor, build, useragent) {
    var regex = /UCBrowser\/(\d+)\.(\d+)\.(\d+)[\.\d]* /;
    // Extract digits from three capturing groups.
    var major_version = stringToInt(extractRegexMatch(useragent, regex, 1));
    var minor_version = stringToInt(extractRegexMatch(useragent, regex, 2));
    var build_version = stringToInt(extractRegexMatch(useragent, regex, 3));
    if (major_version !== major) {
        return major_version > major;
    }
    if (minor_version !== minor) {
        return minor_version > minor;
    }
    return build_version >= build;
};
var getSiteNoneCompatible = function(useragent) {
    return !isSameSiteNoneIncompatible(String(useragent));
};
/* harmony default export */ const cookie_storage_getSiteNoneCompatible = (getSiteNoneCompatible);

;// CONCATENATED MODULE: ./local_modules/cookie-storage/index.ts


var cookieStorage;
if (false) { var ServerCookieStorageProxy; } else {
    // maybe it's better to move it to global variable
    var isSecure = location.protocol === "https:";
    var isSiteNoneCompatible = cookie_storage_getSiteNoneCompatible(window.navigator);
    // on client side we have one storage
    cookieStorage = new cookie_storage_CookieStorage({
        isSecure: isSecure,
        isSiteNoneCompatible: isSiteNoneCompatible
    });
}

/* harmony default export */ const cookie_storage = (cookieStorage);


/***/ }),

/***/ 92091:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);

var Context = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Context);


/***/ }),

/***/ 13610:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var _Context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92091);



var Provider = function(param) {
    var children = param.children, value = param.value;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Context__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z.Provider, {
        value: value,
        children: children
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Provider);


/***/ }),

/***/ 58202:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
var provider;
if (false) {} else {
    provider = (__webpack_require__(13610)/* ["default"] */ .Z);
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (provider);


/***/ }),

/***/ 47361:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var _Provider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92091);


var useDevice = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_Provider__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useDevice);


/***/ }),

/***/ 76671:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85183);
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96669);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_splice_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39479);
/* harmony import */ var core_js_modules_es_array_splice_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6135);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51497);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4__);
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}





var EventEmitter = /*#__PURE__*/ function() {
    "use strict";
    function EventEmitter() {
        _class_call_check(this, EventEmitter);
        _define_property(this, "_listeners", {});
    }
    _create_class(EventEmitter, [
        {
            key: "addListener",
            value: function addListener(eventName, listener) {
                if (!this._listeners[eventName]) {
                    this._listeners[eventName] = [];
                }
                this._listeners[eventName].push(listener);
            }
        },
        {
            key: "once",
            value: function once(eventName, listener) {
                var _this = this;
                var wrapper = function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    listener.apply(void 0, _to_consumable_array(args));
                    _this.removeListener(eventName, wrapper);
                };
                this.addListener(eventName, wrapper);
            }
        },
        {
            key: "removeListener",
            value: function removeListener(eventName, listener) {
                var _this__listeners_eventName;
                if (!((_this__listeners_eventName = this._listeners[eventName]) === null || _this__listeners_eventName === void 0 ? void 0 : _this__listeners_eventName.length)) {
                    return;
                }
                var listenerIndex = this._listeners[eventName].indexOf(listener);
                if (listenerIndex !== -1) {
                    this._listeners[eventName].splice(listenerIndex, 1);
                }
            }
        },
        {
            key: "removeAllListeners",
            value: function removeAllListeners(eventName) {
                if (eventName) {
                    if (this._listeners[eventName]) {
                        this._listeners[eventName] = [];
                    }
                } else {
                    this._listeners = {};
                }
            }
        },
        {
            key: "emit",
            value: function emit(eventName) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                var _this__listeners_eventName;
                if (!((_this__listeners_eventName = this._listeners[eventName]) === null || _this__listeners_eventName === void 0 ? void 0 : _this__listeners_eventName.length)) {
                    return false;
                }
                this._listeners[eventName].forEach(function(listener) {
                    listener.apply(void 0, _to_consumable_array(args));
                });
            }
        },
        {
            key: "hasListeners",
            value: function hasListeners(eventName) {
                var _this__listeners_eventName;
                return ((_this__listeners_eventName = this._listeners[eventName]) === null || _this__listeners_eventName === void 0 ? void 0 : _this__listeners_eventName.length) > 0;
            }
        },
        {
            key: "listeners",
            value: function listeners(eventName) {
                return this._listeners[eventName] || [];
            }
        }
    ]);
    return EventEmitter;
}();
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (EventEmitter);


/***/ }),

/***/ 99214:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var _useEntryListener__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36191);
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}


var useEntry = function() {
    var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _useState = _sliced_to_array((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), 2), entry = _useState[0], setEntry = _useState[1];
    var _useEntryListener = _sliced_to_array((0,_useEntryListener__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(setEntry, opts), 3), ref = _useEntryListener[0], unobserve = _useEntryListener[1], refresh = _useEntryListener[2];
    return [
        ref,
        entry,
        unobserve,
        refresh
    ];
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useEntry);


/***/ }),

/***/ 36191:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ intersection_observer_useEntryListener)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./src/hooks/useDeepMemo.ts
var useDeepMemo = __webpack_require__(15434);
// EXTERNAL MODULE: ./local_modules/intersection-observer/util/createIndividualObserver.ts
var createIndividualObserver = __webpack_require__(93360);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.weak-map.js
var es_weak_map = __webpack_require__(14452);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(5119);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(94218);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(40045);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(51497);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__(6135);
;// CONCATENATED MODULE: ./local_modules/intersection-observer/util/createMasterObserver.ts






var listeners = new WeakMap();
var intersectionObserver;
var createMasterObserver = function() {
    // we should postpone IntersectionObserver initialization, because it should be created after polyfill loading
    if ( true && !intersectionObserver) {
        intersectionObserver = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                var listener = listeners.get(entry.target);
                if (listener) {
                    listener(entry);
                }
            });
        });
    }
    return {
        observe: function(node, listener) {
            if (!intersectionObserver) {
                return;
            }
            listeners.set(node, listener);
            intersectionObserver.observe(node);
        },
        unobserve: function(node) {
            if (!intersectionObserver) {
                return;
            }
            if (listeners.has(node)) {
                listeners["delete"](node);
                intersectionObserver.unobserve(node);
            }
        }
    };
};
/* harmony default export */ const util_createMasterObserver = (createMasterObserver);

;// CONCATENATED MODULE: ./local_modules/intersection-observer/useEntryListener.ts



var useEntryListener = function(listener) {
    var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var ref = (0,react.useRef)();
    var listenerRef = (0,react.useRef)(listener);
    var unobserveRef = (0,react.useRef)(function() {});
    var refreshRef = (0,react.useRef)(function() {});
    // to fix reinitialization on listener change
    listenerRef.current = listener;
    // ATTN this is important to prevent infinity updates
    var once = opts.once, observerProps = opts.observerProps;
    var observerOptions = (0,useDeepMemo/* default */.Z)(function() {
        return observerProps;
    }, [
        observerProps
    ]);
    (0,react.useEffect)(function() {
        var node = ref.current;
        if (!node) {
            return;
        }
        var observer = observerOptions ? (0,createIndividualObserver/* default */.Z)(observerOptions) : util_createMasterObserver();
        // we can't call it twice
        unobserveRef.current = function() {
            observer.unobserve(node);
            unobserveRef.current = function() {};
        };
        var _$listener = function(entry) {
            if (once) {
                // setEntry called once when target become visible in viewport
                if (entry.isIntersecting) {
                    listenerRef.current(entry);
                    unobserveRef.current();
                }
            } else {
                listenerRef.current(entry);
            }
        };
        observer.observe(node, _$listener);
        refreshRef.current = function() {
            observer.unobserve(node);
            observer.observe(node, _$listener);
        };
        return function() {
            unobserveRef.current();
        };
    }, [
        once,
        observerOptions
    ]);
    return [
        ref,
        unobserveRef.current,
        refreshRef.current
    ];
};
/* harmony default export */ const intersection_observer_useEntryListener = (useEntryListener);


/***/ }),

/***/ 73302:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35570);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}


var useSticky = function(opts) {
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var elementRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var stickyRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var setSticky = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(isSticky) {
        if (!containerRef.current || !elementRef.current) {
            return;
        }
        stickyRef.current = isSticky;
        var classNames = [].concat(opts.stickyClass);
        if (isSticky) {
            var _elementRef_current_classList;
            containerRef.current.style = "width:".concat(elementRef.current.clientWidth, "px;height:").concat(elementRef.current.clientHeight, "px");
            (_elementRef_current_classList = elementRef.current.classList).add.apply(_elementRef_current_classList, _to_consumable_array(classNames));
        } else {
            var _elementRef_current_classList1;
            containerRef.current.style = null;
            (_elementRef_current_classList1 = elementRef.current.classList).remove.apply(_elementRef_current_classList1, _to_consumable_array(classNames));
        }
    }, [
        opts.stickyClass
    ]);
    return [
        containerRef,
        elementRef,
        setSticky
    ];
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useSticky);


/***/ }),

/***/ 42209:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93360);
/* This hook fires a callback when some element becomes visible using intersection observer */ 

var useVisibilityTrigger = function(callback) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var skip = options.skip;
    var callbackRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(callback);
    callbackRef.current = callback;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var node = ref.current;
        if (!node || skip) {
            return;
        }
        var observer = (0,_util__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
            threshold: [
                0,
                0.20,
                1
            ]
        });
        var unobserve = function() {
            observer.unobserve(node);
            // we can't call it twice
            unobserve = function() {};
        };
        var listener = function(entry) {
            // if we're intersecting with more that 20% of the item
            var isTriggered = entry.isIntersecting && entry.intersectionRatio > 0.2;
            if (isTriggered) {
                callbackRef.current();
                unobserve();
            }
        };
        observer.observe(node, listener);
        return function() {
            unobserve();
        };
    }, [
        skip
    ]);
    return ref;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useVisibilityTrigger);


/***/ }),

/***/ 93360:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var createIndividualObserver = function(observerProps) {
    var observer;
    return {
        observe: function(node, listener) {
            observer = new IntersectionObserver(function(param) {
                var _param = _sliced_to_array(param, 1), entry = _param[0];
                listener(entry);
            }, observerProps);
            observer.observe(node);
        },
        unobserve: function(node) {
            observer.unobserve(node);
            observer = undefined;
        }
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (createIndividualObserver);


/***/ }),

/***/ 69740:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);

var Context = react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Context);


/***/ }),

/***/ 28637:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ intl_IntlProvider)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/intl/IntlContext.ts
var IntlContext = __webpack_require__(69740);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.function.bind.js
var es_function_bind = __webpack_require__(27641);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(5119);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(94218);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(51497);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__(57890);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__(96837);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__(59690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(17376);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.regexp.constructor.js
var es_regexp_constructor = __webpack_require__(34618);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.regexp.dot-all.js
var es_regexp_dot_all = __webpack_require__(73525);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.regexp.sticky.js
var es_regexp_sticky = __webpack_require__(864);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__(61737);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(35570);
;// CONCATENATED MODULE: ./local_modules/intl/util/replaceSimpleVariables.ts
/**
 * Replace pure {value} variables
 *
 * message: "Price - ${value}"
 * values: { value: 100 }
 *
 * result: Price - $100
 */ 









var replaceSimpleVariables = function(message) {
    var values = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return(// there is no way to math variables first and then iterate by them, coz if we try to find {variable} we match
    // variables in variables - {sex, select, female {perfume} male {cologne} unisex {fragrance}}
    Object.keys(values).reduce(function(res, key) {
        var value = values[key];
        if (value === null || value === undefined) {
            return res;
        }
        // prevent of replacing value in variables (that matching the variable name)
        // example message - 'Some {key} with {check, plural, one {key} other {something}}'
        // const escapeFormulasRegexp = `{${key}}(?!([^{]+)?(({[^{}]+}([^{}]+)?)+)?})`
        //
        // here the ductape "() => values[key]" to fix Safari 11.* bug - '{value}'.replace(/{value}/g, '$14.95') becomes '4.95'
        return res.replace(new RegExp("{".concat(key, "}"), "g"), function() {
            return value;
        });
    }, message));
};
/* harmony default export */ const util_replaceSimpleVariables = (replaceSimpleVariables);

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.string.match.js
var es_string_match = __webpack_require__(73281);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__(6135);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__(26239);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__(56690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__(43474);
;// CONCATENATED MODULE: ./local_modules/intl/util/plural.ts
// CLDR - https://www.unicode.org/cldr/charts/34/supplemental/language_plural_rules.html




var plural = {
    en: function(n, ord) {
        var s = String(n).split(".");
        var v0 = !s[1];
        var t0 = Number(s[0]) === n;
        var n10 = t0 && Number(s[0].slice(-1));
        var n100 = t0 && Number(s[0].slice(-2));
        if (n === 0) {
            return "zero";
        }
        if (ord) {
            if (n10 === 1 && n100 !== 11) {
                return "one";
            }
            if (n10 === 2 && n100 !== 12) {
                return "two";
            }
            if (n10 === 3 && n100 !== 13) {
                return "few";
            }
            return "other";
        }
        if (n === 1 && v0) {
            return "one";
        }
        if (n === 2 && v0) {
            return "two";
        }
        return "other";
    }
};
/* harmony default export */ const util_plural = (plural);

;// CONCATENATED MODULE: ./local_modules/intl/util/getVariableValues.ts
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}




/**
 * variable: "{sex, select, female {perfume} male {cologne} unisex {fragrance}}"
 *
 * result: { female: 'perfume', male: 'cologne', unisex: 'fragrance' }
 */ var getVariableValues = function(variable) {
    return variable.match(/[^\s]+ {[^}]*}/g).reduce(function(obj, item) {
        var _item_match = _sliced_to_array(item.match(/(.+) {(.*)}/), 3), match = _item_match[0], key = _item_match[1], value = _item_match[2];
        return _object_spread_props(_object_spread({}, obj), _define_property({}, key, value));
    }, {});
};
/* harmony default export */ const util_getVariableValues = (getVariableValues);

;// CONCATENATED MODULE: ./local_modules/intl/util/replacePluralVariables.ts








var variableRegex = /{\w+, plural,(\s\w+ {.+?}){2,}}/g;
/**
 * Replace variables with value based on passed values
 *
 * message: "{count, plural, one {# product} other {# products}}"
 * values: { count: 23 }
 *
 * result: 23 products
 */ var replacePluralVariables = function(message, values, locale) {
    var variables = message.match(variableRegex) // [ '{count, plural, one {# product} other {# products}}' ]
    ;
    if (variables === null || variables === void 0 ? void 0 : variables.length) {
        try {
            variables.forEach(function(variable) {
                var variableValues = util_getVariableValues(variable);
                var valueKey = variable.match(/[^,{]+/)[0] // count
                ;
                var value = values ? values[valueKey] : null // 23
                ;
                var variableKey;
                var result;
                // if value not passed set pluralKey value from the variable (first item) - other
                if (value === null || value === undefined) {
                    // TODO trigger error - added on 10/12/20 by pavelivanov
                    variableKey = "other" in variableValues ? "other" : Object.keys(variableValues)[0];
                    result = variableValues[variableKey].replace(/#\s?/g, "") // products
                    ;
                } else {
                    variableKey = util_plural[locale](value) // other
                    ;
                    if (!variableValues[variableKey]) {
                        variableKey = "other";
                    }
                    result = variableValues[variableKey].replace(/#/g, value) // 23 products
                    ;
                }
                message = message.replace(variable, result);
            });
        } catch (err) {}
    }
    return message;
};
/* harmony default export */ const util_replacePluralVariables = (replacePluralVariables);

;// CONCATENATED MODULE: ./local_modules/intl/util/replaceSelectVariables.ts







var replaceSelectVariables_variableRegex = /{\w+, select,(\s\w+ {[^}]+}){2,}}/g;
/**
 * Replace variables with value based on passed values
 *
 * message: "{sex, select, female {perfume} male {cologne} unisex {fragrance}}"
 * values: { sex: 'female' }
 *
 * result: perfume
 */ var replaceSelectVariable = function(message, values, variable) {
    var _variableValues_variableKey;
    var variableValues = util_getVariableValues(variable);
    var valueKey = variable.match(/(?!{)\w+/)[0] // sex
    ;
    var variableKey = values ? values[valueKey] : null // female
    ;
    // if value not passed set value from the variable (first item) - unisex
    if (variableKey === undefined || variableValues[variableKey] === undefined) {
        // TODO trigger error - added on 10/12/20 by pavelivanov
        variableKey = "other" in variableValues ? "other" : Object.keys(variableValues)[0];
    }
    var result = (_variableValues_variableKey = variableValues[variableKey]) === null || _variableValues_variableKey === void 0 ? void 0 : _variableValues_variableKey.replace(/#/g, values === null || values === void 0 ? void 0 : values[valueKey]);
    return message.replace(variable, result);
};
var replaceSelectVariables = function(message, values) {
    var variables = message.match(replaceSelectVariables_variableRegex) // [ '{sex, select, female {perfume} male {cologne} unisex {fragrance}}' ]
    ;
    if (variables === null || variables === void 0 ? void 0 : variables.length) {
        try {
            variables.forEach(function(variable) {
                message = replaceSelectVariable(message, values, variable);
            });
        } catch (err) {
            console.error(err);
        }
    }
    return message;
};
/* harmony default export */ const util_replaceSelectVariables = (replaceSelectVariables);

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__(79006);
;// CONCATENATED MODULE: ./local_modules/intl/util/stripSpaces.ts



var stripSpaces = function(message) {
    return message.replace(/\s{2,}/g, " ").replace(/<br\s?\/>\s+/g, "<br />").replace(/{\s+/, "{").replace(/\s+}/, "}").trim();
};
/* harmony default export */ const util_stripSpaces = (stripSpaces);

;// CONCATENATED MODULE: ./local_modules/intl/formatMessage.ts







var formatMessage = function() {
    var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "en", message = arguments.length > 1 ? arguments[1] : void 0, values = arguments.length > 2 ? arguments[2] : void 0;
    if (typeof message === "string") {
        return message;
    }
    // TODO add error handler - added on 10/9/20 by pavelivanov
    if (!message) {
        return "{{ missed_translation }}";
    }
    var fMessage = util_stripSpaces(message[locale]);
    var fValues = values || (message === null || message === void 0 ? void 0 : message.values);
    fMessage = util_replaceSelectVariables(fMessage, fValues);
    fMessage = util_replacePluralVariables(fMessage, fValues, locale);
    fMessage = util_replaceSimpleVariables(fMessage, fValues);
    return fMessage || "{{ missed_translation }}";
};
/* harmony default export */ const intl_formatMessage = (formatMessage);

;// CONCATENATED MODULE: ./local_modules/intl/createIntl.ts


var createIntl = function(param) {
    var locale = param.locale, setLocale = param.setLocale, onError = param.onError;
    return {
        formatMessage: intl_formatMessage.bind(null, locale),
        setLocale: setLocale
    };
};
/* harmony default export */ const intl_createIntl = (createIntl);

;// CONCATENATED MODULE: ./local_modules/intl/IntlProvider.tsx
function IntlProvider_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function IntlProvider_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function IntlProvider_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function IntlProvider_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function IntlProvider_sliced_to_array(arr, i) {
    return IntlProvider_array_with_holes(arr) || IntlProvider_iterable_to_array_limit(arr, i) || IntlProvider_unsupported_iterable_to_array(arr, i) || IntlProvider_non_iterable_rest();
}
function IntlProvider_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return IntlProvider_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return IntlProvider_array_like_to_array(o, minLen);
}




var IntlProvider = function(props) {
    var children = props.children, initialLocale = props.locale, onError = props.onError;
    var _useState = IntlProvider_sliced_to_array((0,react.useState)(initialLocale), 2), locale = _useState[0], setLocale = _useState[1];
    var intl = (0,react.useMemo)(function() {
        return intl_createIntl({
            locale: locale,
            setLocale: setLocale,
            onError: onError
        });
    }, [
        locale
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IntlContext/* default */.Z.Provider, {
        value: intl,
        children: children
    });
};
/* harmony default export */ const intl_IntlProvider = (IntlProvider);


/***/ }),

/***/ 17696:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ intl_Message)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(5119);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(94218);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(51497);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__(83464);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(72463);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/intl/useIntl.ts
var useIntl = __webpack_require__(56376);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.regexp.test.js
var es_regexp_test = __webpack_require__(46781);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(17376);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__(59690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__(79006);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__(26239);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__(6135);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.string.match.js
var es_string_match = __webpack_require__(73281);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__(43474);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__(8946);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.regexp.constructor.js
var es_regexp_constructor = __webpack_require__(34618);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.regexp.dot-all.js
var es_regexp_dot_all = __webpack_require__(73525);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.regexp.sticky.js
var es_regexp_sticky = __webpack_require__(864);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__(61737);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(35570);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__(57890);
;// CONCATENATED MODULE: ./local_modules/intl/util/replaceReactComponents.ts
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_array(arr) {
    return _array_with_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}



















// <Button boolAttr1 valueAttr1="/queue" valueAttr2=" value " emptyAttr="" boolAttr2>content</Button>
var getComponentProps = function(message) {
    var props = {};
    if (/<\w+\s*(\/>|>)/.test(message)) {
        return;
    }
    var attrsPart = message.replace(/^<\w+\s+([^>]+?)\/?>.*/, "$1") // leave only part with attributes - 'boolAttr1 valueAttr1="/queue" valueAttr2=" value " emptyAttr="" boolAttr2'
    .replace(/\s*=\s*/g, "=") // strip spaces around `=`
    ;
    // to match all empty attributes with regex too complex, so
    var emptyProps = attrsPart.replace(/\w+\s*=\s*["'].*?["']/g, "") // strip attributes with values - 'boolAttr1    boolAttr2'
    .trim().split(/\s+/g) // split empty attributes - [ 'boolAttr1', 'boolAttr2' ]
    ;
    emptyProps.forEach(function(prop) {
        if (prop) {
            props[prop] = true;
        }
    });
    var valuedProps = attrsPart.trim().match(/\w+\s*=\s*['"][^"]*?['"]/g) // [ 'valueAttr1="/queue"', 'valueAttr2=" value "', 'emptyAttr=""' ]
    ;
    valuedProps.forEach(function(match) {
        // collect values to array, in case of '=' in value
        // e.g. to="/log-in?redirect=some-url&review=5"
        var _match_trim_split = _to_array(match.trim().split("=")), key = _match_trim_split[0], valueArr = _match_trim_split.slice(1);
        var value = valueArr.join("=");
        if (value) {
            value = value.replace(/['"]/g, "");
        }
        if (value === "true") {
            value = true;
        } else if (value === "false") {
            value = false;
        }
        props[key] = value;
    });
    return props;
};
var getComponentChildren = function(message) {
    var componentName = message.match(/<(\w+)/)[1];
    // <Icon />
    if (/^<[^>]+\/>$/.test(message)) {
        return undefined;
    }
    // <Link to="/">bar</Link>
    // complex regex to be sure that value be matched properly even if the content is "< apple>banana<grape>"
    return message.match(new RegExp("<\\s*".concat(componentName, "[^>]*?>(.*)</\\s*").concat(componentName, "\\s*>")))[1];
};
var createComponent = function(message, components) {
    try {
        var componentName = message.match(/<(\w+)/)[1];
        var component = components[componentName];
        var props = getComponentProps(message);
        var children = getComponentChildren(message);
        return react.createElement(component, props, children);
    } catch (err) {
        console.error(err);
        // TODO add error handling - added on 10/12/20 by pavelivanov
        return null;
    }
};
/**
 * Replace components in string message with components create with React.createElement
 *
 * message: "foo <Link to="/">bar</Link> zoo <Icon /> baz <Button>kek</Button>"
 * components: { Link: Link, Icon: Icon, Button: Button }
 *
 * result:
 *
 * [
 *   "foo ",
 *   React.createElement(Link, { to: '/' }, 'bar'),
 *   " zoo ",
 *   React.createElement(Icon),
 *   " baz ",
 *   "<Href>kek</Href>",
 * ]
 */ var replaceReactComponents = function(message, components) {
    var componentNames = Object.keys(components || {});
    if (!componentNames.length) {
        return [
            message
        ];
    }
    var compoRegexStr = componentNames.join("|") // Link|Icon|Button
    ;
    var splitRegex = new RegExp("(<\\s*(?:".concat(compoRegexStr, ")(?:[^>]+?/>|.+?(?:").concat(compoRegexStr, "\\s*)>))"), "g");
    var messageArr = message.split(splitRegex);
    return messageArr.map(function(message) {
        // check that this message part contains a component
        if (new RegExp("<".concat(compoRegexStr)).test(message)) {
            return createComponent(message, components);
        }
        return message;
    }).filter(function(v) {
        return v;
    });
};
/* harmony default export */ const util_replaceReactComponents = (replaceReactComponents);

;// CONCATENATED MODULE: ./local_modules/intl/Message.tsx
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}









var Message = function(props) {
    var value = props.value, _props_tag = props.tag, tag = _props_tag === void 0 ? "span" : _props_tag, html = props.html;
    var intl = (0,useIntl/* default */.Z)();
    if (!value) {
        // TODO handle error - added on 10/13/20 by pavelivanov
        return null;
    }
    if (typeof value === "string") {
        if (html) {
            return /*#__PURE__*/ react.createElement(tag, {
                dangerouslySetInnerHTML: {
                    __html: value
                }
            });
        }
        // TODO handle error - added on 10/13/20 by pavelivanov
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
            children: value
        });
    }
    var values = value.values, components = value.components, message = _object_without_properties(value, [
        "values",
        "components"
    ]);
    var formattedMessage = intl.formatMessage(message, values);
    if (components) {
        var formattedMessageArr = util_replaceReactComponents(formattedMessage, components);
        var children = formattedMessageArr.filter(function(messageItem) {
            return messageItem;
        }).map(function(messageItem, index) {
            if (typeof messageItem === "object") {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                    children: messageItem
                }, index);
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                dangerouslySetInnerHTML: {
                    __html: messageItem
                }
            }, index);
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
            children: children
        });
    }
    if (html) {
        return /*#__PURE__*/ react.createElement(tag, {
            dangerouslySetInnerHTML: {
                __html: formattedMessage
            }
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: formattedMessage
    });
};
/* harmony default export */ const intl_Message = (Message);


/***/ }),

/***/ 56376:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var _IntlContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69740);


var useIntl = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_IntlContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useIntl);


/***/ }),

/***/ 55222:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ local_storage)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.error.cause.js
var es_error_cause = __webpack_require__(68471);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.error.to-string.js
var es_error_to_string = __webpack_require__(86011);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__(57890);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__(62100);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__(69453);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(28950);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.json.stringify.js
var es_json_stringify = __webpack_require__(76189);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(85183);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(5119);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(94218);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(51497);
// EXTERNAL MODULE: ./local_modules/logger/index.ts
var logger = __webpack_require__(58738);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.map.js
var es_map = __webpack_require__(78986);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(40045);
;// CONCATENATED MODULE: ./local_modules/local-storage/MemoryStorage.ts
// This class is fallback storage when localStorage is blocked
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}





var MemoryStorage = /*#__PURE__*/ function() {
    "use strict";
    function MemoryStorage() {
        _class_call_check(this, MemoryStorage);
        _define_property(this, "storage", new Map());
    }
    _create_class(MemoryStorage, [
        {
            key: "length",
            get: function get() {
                return this.storage.size;
            }
        },
        {
            key: "key",
            value: function key(index) {
                return this.storage.keys()[index] || null;
            }
        },
        {
            key: "getItem",
            value: function getItem(key) {
                if (this.storage.has(key)) {
                    return this.storage.get(key);
                }
                return null;
            }
        },
        {
            key: "setItem",
            value: function setItem(key, value) {
                this.storage.set(key, value);
            }
        },
        {
            key: "removeItem",
            value: function removeItem(key) {
                this.storage["delete"](key);
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.storage.clear();
            }
        }
    ]);
    return MemoryStorage;
}();
/* harmony default export */ const local_storage_MemoryStorage = (MemoryStorage);

;// CONCATENATED MODULE: ./local_modules/local-storage/LocalStorage.ts
function LocalStorage_class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function LocalStorage_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function LocalStorage_create_class(Constructor, protoProps, staticProps) {
    if (protoProps) LocalStorage_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) LocalStorage_defineProperties(Constructor, staticProps);
    return Constructor;
}
function LocalStorage_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}













var ffErrors = [
    "NS_ERROR_FAILURE",
    "NS_ERROR_FILE_CORRUPTED",
    "NS_ERROR_FILE_NO_DEVICE_SPACE"
];
var LocalStorage = /*#__PURE__*/ function() {
    "use strict";
    function LocalStorage() {
        LocalStorage_class_call_check(this, LocalStorage);
        LocalStorage_define_property(this, "memoryLocalStorage", void 0);
        LocalStorage_define_property(this, "memorySessionStorage", void 0);
        // to show error alert only once
        LocalStorage_define_property(this, "corruptedAlertWasShowed", false);
        if ( false || !LocalStorage.isSupported(function() {
            return localStorage;
        })) {
            this.memoryLocalStorage = new local_storage_MemoryStorage();
        }
        if ( false || !LocalStorage.isSupported(function() {
            return sessionStorage;
        })) {
            this.memorySessionStorage = new local_storage_MemoryStorage();
        }
    }
    LocalStorage_create_class(LocalStorage, [
        {
            key: "getLocalStorage",
            value: function getLocalStorage() {
                return this.memoryLocalStorage || localStorage;
            }
        },
        {
            key: "getSessionStorage",
            value: function getSessionStorage() {
                return this.memorySessionStorage || sessionStorage;
            }
        },
        {
            key: "get",
            value: function get(name, storage) {
                if (false) {}
                try {
                    return JSON.parse(storage.getItem(name));
                } catch (error) {
                    if (ffErrors.includes(error.name)) {
                        this.clear(storage);
                        return null;
                    }
                    logger/* default */.Z.warn({
                        error: error,
                        name: name
                    });
                    this.remove(name, storage) // remove invalid data
                    ;
                    return null;
                }
            }
        },
        {
            key: "set",
            value: function set(name, value, storage) {
                if (false) {}
                try {
                    storage.setItem(name, JSON.stringify(value));
                } catch (error) {
                    logger/* default */.Z.warn({
                        error: error,
                        name: name,
                        value: value
                    });
                    if (ffErrors.includes(error.name)) {
                        this.clear(storage);
                    }
                }
            }
        },
        {
            key: "remove",
            value: function remove(name, storage) {
                if (false) {}
                try {
                    storage.removeItem(name);
                } catch (error) {
                    logger/* default */.Z.warn({
                        error: error,
                        name: name
                    });
                }
            }
        },
        {
            key: "clear",
            value: function clear(storage) {
                if (false) {}
                // Firefox corrupted file error, try to clean up the storage, and ignore error
                // https://stackoverflow.com/questions/18877643/error-in-local-storage-ns-error-file-corrupted-firefox
                try {
                    logger/* default */.Z.info("clean up storage");
                    storage.clear();
                } catch (error) {
                    if (ffErrors.includes(error.name) && !this.corruptedAlertWasShowed) {
                        alert("Sorry, it looks like your browser storage has been corrupted. " + "Please clear your storage by going to Tools -> Clear Recent History -> Cookies and set time range to 'Everything'. " + "This will remove the corrupted browser storage across all sites.");
                        this.corruptedAlertWasShowed = true;
                    }
                    logger/* default */.Z.info(error);
                }
            }
        },
        {
            key: "keys",
            value: function keys(storage) {
                if (false) {}
                var length = storage.length;
                var result = [];
                for(var i = 0; i < length; i++){
                    result.push(storage.key(i));
                }
                return result;
            }
        },
        {
            key: "getItem",
            value: // localStorage
            function getItem(name) {
                return this.get(name, this.getLocalStorage());
            }
        },
        {
            key: "setItem",
            value: function setItem(name, value) {
                this.set(name, value, this.getLocalStorage());
            }
        },
        {
            key: "removeItem",
            value: function removeItem(name) {
                this.remove(name, this.getLocalStorage());
            }
        },
        {
            key: "getKeys",
            value: function getKeys() {
                return this.keys(this.getLocalStorage());
            }
        },
        {
            key: "getSessionItem",
            value: // session storage
            function getSessionItem(name) {
                return this.get(name, this.getSessionStorage());
            }
        },
        {
            key: "setSessionItem",
            value: function setSessionItem(name, value) {
                this.set(name, value, this.getSessionStorage());
            }
        },
        {
            key: "removeSessionItem",
            value: function removeSessionItem(name) {
                this.remove(name, this.getSessionStorage());
            }
        },
        {
            key: "getSessionKeys",
            value: function getSessionKeys() {
                return this.keys(this.getSessionStorage());
            }
        }
    ], [
        {
            key: "isSupported",
            value: // we should check it like this, to avoid "Operation Insecure" errors
            // add replace it with MemoryStorage
            function isSupported(getStorage) {
                try {
                    var testKey = "__some_random_key_you_are_not_going_to_use__";
                    getStorage().setItem(testKey, testKey);
                    getStorage().removeItem(testKey);
                    return true;
                } catch (error) {
                    return false;
                }
            }
        }
    ]);
    return LocalStorage;
}();
/* harmony default export */ const local_storage_LocalStorage = (LocalStorage);

;// CONCATENATED MODULE: ./local_modules/local-storage/index.ts

/* harmony default export */ const local_storage = (new local_storage_LocalStorage());


/***/ }),

/***/ 50632:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ client)
});

// EXTERNAL MODULE: ../../packages/logger/dist/index.js
var dist = __webpack_require__(33349);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(85183);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__(57890);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.string.match.js
var es_string_match = __webpack_require__(73281);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(17376);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__(59690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(35570);
;// CONCATENATED MODULE: ./local_modules/logger/client/consoleTransport.ts
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}







var methodMap = {
    fatal: console.error,
    error: console.error,
    warn: console.warn,
    info: console.info,
    debug: console.debug,
    trace: console.trace
};
var consoleTransport = (0,dist/* buildTransport */.Uj)(function(source) {
    var time = source.time, level = source.level, message = source.message, error = source.error, rest = _object_without_properties(source, [
        "time",
        "level",
        "message",
        "error"
    ]);
    var method = methodMap[level] || console.log;
    var args = colorizeMessage(message);
    if (error) {
        var composedError = (0,dist/* composeError */.hs)(error);
        args.push("\n", composedError);
        if (composedError.cause) {
            args.push("\n\nCaused by", composedError.cause);
        }
    }
    if (Object.keys(rest).length > 0) {
        args.push(rest);
    }
    method.apply(void 0, _to_consumable_array(args));
}, {
    parse: true
});
var analyticsStyle = "font-weight: bold; color: #0000FF;";
var colorizeMessage = function(message) {
    if (typeof message === "string") {
        var match = message.match(/(\[(Mixpanel|Snowplow|DataLayer|Iterable|Attentive)])( (track) (.*)|)/);
        if (match) {
            if (match[3].length) {
                // track case
                return [
                    message.replace(match[0], "%c".concat(match[1], " %c").concat(match[4], " %c").concat(match[5])),
                    analyticsStyle,
                    "",
                    "font-weight: bold;"
                ];
            }
            return [
                message.replace(match[0], "%c".concat(match[1], "%c")),
                analyticsStyle,
                ""
            ];
        }
    }
    if (message) {
        return [
            message
        ];
    }
    return [];
};

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__(62100);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__(69453);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@sentry+core@7.93.0/node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(79981);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@sentry+core@7.93.0/node_modules/@sentry/core/esm/hub.js
var hub = __webpack_require__(20526);
;// CONCATENATED MODULE: ./local_modules/logger/client/sentryTransport.ts
function sentryTransport_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = sentryTransport_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function sentryTransport_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var sentryLevelMap = {
    fatal: "fatal",
    error: "error",
    warn: "warning",
    info: "info",
    debug: "debug",
    trace: "log"
};
var sentryTransport = function(options) {
    var levels = options.levels;
    return (0,dist/* buildTransport */.Uj)(function(source) {
        var message = source.message, error = source.error, level = source.level, rest = sentryTransport_object_without_properties(source, [
            "message",
            "error",
            "level"
        ]);
        var severity = sentryLevelMap[level] || "log";
        if (!levels.includes(severity)) {
            esm_exports/* addBreadcrumb */.n_({
                category: "log",
                level: severity,
                message: String(message),
                data: rest
            });
            return;
        }
        if (hub/* getCurrentHub */.Gd()) {
            esm_exports/* withScope */.$e(function(scope) {
                scope.setLevel(severity);
                scope.setContext("log-record", source);
                if (error) {
                    var composedError = (0,dist/* composeError */.hs)(error);
                    esm_exports/* captureException */.Tb(composedError);
                } else {
                    esm_exports/* captureMessage */.uT(message);
                }
            });
        }
    }, {
        parse: true
    });
};

;// CONCATENATED MODULE: ./local_modules/logger/client/index.ts



var logger = new dist/* Logger */.Yd({
    transports: [
        consoleTransport,
        sentryTransport({
            levels: [
                "error",
                "fatal"
            ]
        })
    ]
});
/* harmony default export */ const client = (logger);


/***/ }),

/***/ 58738:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
var logger;
if (false) {} else if (false) {} else {
    logger = (__webpack_require__(50632)/* ["default"] */ .Z);
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (logger);


/***/ }),

/***/ 98119:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5119);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94218);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51497);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54939);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14939);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62040);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(40045);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(28950);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35570);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85183);
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(52983);
/* harmony import */ var logger__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(58738);
/* harmony import */ var _manager__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(31978);
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}














var ModalsRenderer = function() {
    var _useState = _sliced_to_array((0,react__WEBPACK_IMPORTED_MODULE_11__.useState)(0), 2), _ = _useState[0], update = _useState[1];
    (0,react__WEBPACK_IMPORTED_MODULE_11__.useEffect)(function() {
        var listener = function() {
            update(function(value) {
                return value + 1;
            });
        };
        _manager__WEBPACK_IMPORTED_MODULE_12__/* .manager */ .BP.subscribe(listener);
        // force update to rerender
        listener();
        return function() {
            _manager__WEBPACK_IMPORTED_MODULE_12__/* .manager */ .BP.unsubscribe(listener);
        };
    }, []);
    var nodes = [];
    var index = -1;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = _manager__WEBPACK_IMPORTED_MODULE_12__/* .manager */ .BP.getState().entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = _sliced_to_array(_step.value, 2), id = _step_value[0], _step_value_ = _step_value[1], name = _step_value_.name, props = _step_value_.props, closeModal = _step_value_.closeModal, isStandalone = _step_value_.isStandalone;
            // we use global index for every modal
            index++;
            // skip standalone modals, they render themselves
            if (isStandalone) {
                continue;
            }
            if (!_manager__WEBPACK_IMPORTED_MODULE_12__/* .modalsRegistry */ .BX[name]) {
                logger__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z.error('Modal "'.concat(name, '" not found'));
                continue;
            }
            var Component = _manager__WEBPACK_IMPORTED_MODULE_12__/* .modalsRegistry */ .BX[name];
            nodes.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(Component, _object_spread({
                name: name,
                closeModal: closeModal,
                index: index
            }, props), id));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.Fragment, {
        children: nodes
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ModalsRenderer);


/***/ }),

/***/ 31978:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   BM: () => (/* binding */ isAnyModalOpen),
/* harmony export */   BP: () => (/* binding */ manager),
/* harmony export */   BX: () => (/* binding */ modalsRegistry),
/* harmony export */   My: () => (/* binding */ preloadModal),
/* harmony export */   gP: () => (/* binding */ isModalOpen),
/* harmony export */   h: () => (/* binding */ registerModals),
/* harmony export */   h7: () => (/* binding */ openModal)
/* harmony export */ });
/* unused harmony export closeModal */
/* harmony import */ var core_js_modules_es_map_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78986);
/* harmony import */ var core_js_modules_es_map_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5119);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94218);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40045);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51497);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35570);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6135);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(28950);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(54939);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(14939);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(62040);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(57890);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(40963);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(72463);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(68471);
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_error_to_string_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(86011);
/* harmony import */ var core_js_modules_es_error_to_string_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_error_to_string_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var event_emitter__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(76671);
/* harmony import */ var logger__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(58738);
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


















var modalsRegistry = {};
var ModalManager = /*#__PURE__*/ function() {
    "use strict";
    function ModalManager() {
        _class_call_check(this, ModalManager);
        _define_property(this, "events", new event_emitter__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z());
        _define_property(this, "state", new Map());
        _define_property(this, "standaloneModals", {});
        _define_property(this, "lastId", 0);
    }
    _create_class(ModalManager, [
        {
            key: "generateId",
            value: function generateId() {
                return this.lastId++;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(listener) {
                this.events.addListener("change", listener);
            }
        },
        {
            key: "unsubscribe",
            value: function unsubscribe(listener) {
                this.events.removeListener("change", listener);
            }
        },
        {
            key: "emit",
            value: function emit() {
                this.events.emit("change");
            }
        },
        {
            key: "openModal",
            value: function openModal(name, props) {
                var _this = this;
                var id = this.generateId();
                var isStandalone = this.standaloneModals[name] > 0;
                var closeModal = function(withOnClose) {
                    _this.state["delete"](id);
                    _this.emit();
                    logger__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z.debug('Close "'.concat(name, '" modal'));
                    if (withOnClose === true && typeof (props === null || props === void 0 ? void 0 : props.onClose) === "function") {
                        props === null || props === void 0 ? void 0 : props.onClose();
                    }
                };
                this.state.set(id, {
                    name: name,
                    props: props,
                    closeModal: closeModal,
                    isStandalone: isStandalone
                });
                this.emit();
                logger__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z.debug({
                    props: props
                }, 'Open "'.concat(name, '" modal'));
                return closeModal;
            }
        },
        {
            key: "closeModal",
            value: // closes every modal with requested name
            function closeModal(name) {
                var _this = this;
                this.state.forEach(function(value, key) {
                    if (value.name === name) {
                        _this.state["delete"](key);
                        logger__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z.debug('Close "'.concat(name, '" modal'));
                    }
                });
                this.emit();
            }
        },
        {
            key: "getState",
            value: function getState() {
                return this.state;
            }
        },
        {
            key: "markAsStandalone",
            value: function markAsStandalone(name) {
                this.standaloneModals[name] = (this.standaloneModals[name] || 0) + 1;
            }
        },
        {
            key: "unmarkAsStandalone",
            value: function unmarkAsStandalone(name) {
                this.standaloneModals[name] = (this.standaloneModals[name] || 1) - 1;
            }
        },
        {
            key: "isModalOpen",
            value: function isModalOpen(name) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.state.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var item = _step.value;
                        if (item.name === name) {
                            return true;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return false;
            }
        },
        {
            key: "isAnyModalOpen",
            value: function isAnyModalOpen() {
                return this.state.size > 0;
            }
        }
    ]);
    return ModalManager;
}();
var manager = new ModalManager();
var openModal = function(name, props) {
    return manager.openModal(name, props);
};
var closeModal = function(name) {
    return manager.closeModal(name);
};
var registerModals = function(registry) {
    Object.keys(registry).forEach(function(key) {
        modalsRegistry[key] = registry[key];
    });
    // unregister function
    return function() {
        Object.keys(registry).forEach(function(key) {
            delete modalsRegistry[key];
        });
    };
};
var preloadModal = function() {
    for(var _len = arguments.length, names = new Array(_len), _key = 0; _key < _len; _key++){
        names[_key] = arguments[_key];
    }
    return Promise.all(names.map(function(name) {
        if (!modalsRegistry[name]) {
            throw new Error("Can't preload unregistered modal \"".concat(name, '"'));
        }
        var modal = modalsRegistry[name];
        return typeof modal.load === "function" ? modal.load() : Promise.resolve();
    })).then(function() {});
};
var isModalOpen = function(name) {
    return manager.isModalOpen(name);
};
var isAnyModalOpen = function() {
    return manager.isAnyModalOpen();
};


/***/ }),

/***/ 8813:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85183);
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83464);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51497);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5119);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94218);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54939);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14939);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(62040);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(40045);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(28950);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(35570);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(52983);
/* harmony import */ var _manager__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(31978);
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}














// to render a modal in-place without registration required
var standaloneModal = function(modalName, Component) {
    // ATTN because we can render several instances of standaloneModal,
    //  we should track them and render only in the active one
    var lastId = 1;
    var activeIds = [];
    var Wrapper = function() {
        var _useState = _sliced_to_array((0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(0), 2), forceUpdate = _useState[1];
        var instanceIdRef = (0,react__WEBPACK_IMPORTED_MODULE_12__.useRef)(null);
        if (!instanceIdRef.current) {
            instanceIdRef.current = lastId++;
        }
        (0,react__WEBPACK_IMPORTED_MODULE_12__.useEffect)(function() {
            var listener = function() {
                forceUpdate(function(value) {
                    return value + 1;
                });
            };
            activeIds.push(instanceIdRef.current);
            _manager__WEBPACK_IMPORTED_MODULE_13__/* .manager */ .BP.subscribe(listener);
            _manager__WEBPACK_IMPORTED_MODULE_13__/* .manager */ .BP.markAsStandalone(modalName);
            // Force update if modal was open before
            listener();
            return function() {
                activeIds = activeIds.filter(function(value) {
                    return value !== instanceIdRef.current;
                });
                _manager__WEBPACK_IMPORTED_MODULE_13__/* .manager */ .BP.unsubscribe(listener);
                _manager__WEBPACK_IMPORTED_MODULE_13__/* .manager */ .BP.unmarkAsStandalone(modalName);
            };
        }, []);
        // ATTN show only if this instance is the first instance of this modal
        if (activeIds[0] !== instanceIdRef.current) {
            return null;
        }
        var nodes = [];
        var index = -1;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = _manager__WEBPACK_IMPORTED_MODULE_13__/* .manager */ .BP.getState().entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = _sliced_to_array(_step.value, 2), id = _step_value[0], _step_value_ = _step_value[1], name = _step_value_.name, props = _step_value_.props, closeModal = _step_value_.closeModal;
                index++;
                if (modalName === name) {
                    nodes.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(Component, _object_spread({
                        name: name,
                        closeModal: closeModal,
                        index: index
                    }, props), id));
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.Fragment, {
            children: nodes
        });
    };
    Wrapper.displayName = "modal(".concat(Component.displayName || Component.name || modalName, ")");
    return Wrapper;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (standaloneModal);


/***/ }),

/***/ 93231:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35570);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73598);
/* harmony import */ var core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72463);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28950);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52983);
/* harmony import */ var device__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47361);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50556);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(48073);
/* harmony import */ var modals__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(31978);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(51827);
/* harmony import */ var _manager__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72065);
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}











var Notification = function(param) {
    var id = param.id, component = param.component, componentProps = param.componentProps;
    var handleClose = (0,react__WEBPACK_IMPORTED_MODULE_5__.useCallback)(function() {
        (0,_manager__WEBPACK_IMPORTED_MODULE_6__/* .closeNotification */ .vU)(id);
    }, [
        id
    ]);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_5__.createElement(component, _object_spread_props(_object_spread({}, componentProps), {
        closeNotification: handleClose
    }));
};
var Notifications = function(props) {
    var className = props.className, templates = props.templates;
    var isCartAutoOpenEnabled = (0,hooks__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z.abTests.cartNotificationDesignUpdate) === "a";
    var _useState = _sliced_to_array((0,react__WEBPACK_IMPORTED_MODULE_5__.useState)([]), 2), notifications = _useState[0], setNotifications = _useState[1];
    var isMobile = (0,device__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)().isMobile;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_5__.useRef)();
    var prevOffsetRef = (0,react__WEBPACK_IMPORTED_MODULE_5__.useRef)();
    var hasNotificationsRef = (0,react__WEBPACK_IMPORTED_MODULE_5__.useRef)();
    hasNotificationsRef.current = notifications.length > 0;
    var setOffset = function(newOffset) {
        if (prevOffsetRef.current !== newOffset) {
            ref.current.style.transform = "translateY(".concat(newOffset, "px)");
            prevOffsetRef.current = newOffset;
        }
    };
    // Set offset to keep notifications below the main header
    var updateOffset = function() {
        // Do not update offset if there are no notifications
        if (!ref.current || !hasNotificationsRef.current) {
            return;
        }
        // Reset offset if needed when any modal is open or user scrolled more than 1/4 of the screen
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        if ((0,modals__WEBPACK_IMPORTED_MODULE_10__/* .isAnyModalOpen */ .BM)() || scrollTop > innerHeight / 4) {
            setOffset(0);
            return;
        }
        // Update offset if needed when main header is visible
        var mainHeaderElement = document.querySelector("#main-header");
        if (mainHeaderElement) {
            var mainHeaderRect = mainHeaderElement.getBoundingClientRect();
            var margin = (isMobile ? 4 : -8) - 16 // icon margin - position top
            ;
            var offset = Math.max(mainHeaderRect.bottom + (0,helpers__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(margin), 0);
            setOffset(offset);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(function() {
        setOffset(0);
        if (isCartAutoOpenEnabled) {
            return;
        }
        var interval = setInterval(function() {
            requestAnimationFrame(updateOffset);
        }, 200);
        return function() {
            return clearInterval(interval);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(function() {
        (0,_manager__WEBPACK_IMPORTED_MODULE_6__/* .subscribe */ .Ld)(setNotifications);
        return function() {
            (0,_manager__WEBPACK_IMPORTED_MODULE_6__/* .unsubscribe */ .r1)(setNotifications);
        };
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: className,
        ref: ref,
        children: notifications.map(function(param) {
            var id = param.id, name = param.name, _$props = param.props;
            var component = templates[name];
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(Notification, {
                id: id,
                component: component,
                componentProps: _$props
            }, id);
        })
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.memo(Notifications));


/***/ }),

/***/ 72065:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Ld: () => (/* binding */ subscribe),
/* harmony export */   Ym: () => (/* binding */ openNotification),
/* harmony export */   r1: () => (/* binding */ unsubscribe),
/* harmony export */   vU: () => (/* binding */ closeNotification)
/* harmony export */ });
/* unused harmony export closeAllNotifications */
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35570);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8055);
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51497);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83464);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28950);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6135);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var event_emitter__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(76671);
/* harmony import */ var logger__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(58738);
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}








var events = new event_emitter__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z();
var notifications = [];
var notificationId = 1;
var subscribe = function(handler) {
    events.addListener("change", handler);
};
var unsubscribe = function(handler) {
    events.removeListener("change", handler);
};
var openNotification = function(name, props) {
    var currentNotificationId = ++notificationId;
    var notification = {
        id: currentNotificationId,
        name: name,
        props: props
    };
    notifications = _to_consumable_array(notifications).concat([
        notification
    ]);
    logger__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z.debug({
        props: props
    }, 'Open "'.concat(name, '" notification'));
    events.emit("change", notifications);
    return currentNotificationId;
};
var closeNotification = function(id) {
    var notification = notifications.find(function(notification) {
        return notification.id === id;
    });
    if (notification) {
        notifications = notifications.filter(function(notification) {
            return notification.id !== id;
        });
        logger__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z.debug('Close "'.concat(notification.name, '" notification'));
        events.emit("change", notifications);
    }
};
var closeAllNotifications = function() {
    notifications.forEach(function(notification) {
        closeNotification(notification.id);
    });
};



/***/ }),

/***/ 87867:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ svg_provider_BrowserRuntime)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.map.js
var es_map = __webpack_require__(78986);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(5119);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(94218);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(40045);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(51497);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__(6135);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(35570);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__(79006);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__(57890);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__(59690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(17376);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.string.match.js
var es_string_match = __webpack_require__(73281);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__(96837);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__(26239);
// EXTERNAL MODULE: ./local_modules/logger/index.ts
var logger = __webpack_require__(58738);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.regexp.constructor.js
var es_regexp_constructor = __webpack_require__(34618);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.regexp.dot-all.js
var es_regexp_dot_all = __webpack_require__(73525);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.regexp.sticky.js
var es_regexp_sticky = __webpack_require__(864);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__(61737);
;// CONCATENATED MODULE: ./local_modules/svg-provider/util/randomizeString.ts
var randomizeString = function() {
    var length = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 8;
    var letters = "abcdefghijklmnopqrstuvwxyz";
    var numbers = "1234567890";
    var charset = letters + letters.toUpperCase() + numbers;
    var randomCharacter = function(array) {
        return array[Math.floor(Math.random() * array.length)];
    };
    var R = "";
    for(var i = 0; i < length; i++){
        R += randomCharacter(charset);
    }
    return R;
};
/* harmony default export */ const util_randomizeString = (randomizeString);

;// CONCATENATED MODULE: ./local_modules/svg-provider/util/replaceSvgIds.ts








var getAttributePattern = function(attr) {
    return "(?:(?:\\s|\\:)".concat(attr, ")");
};
// eslint-disable-next-line max-len
var idPattern = new RegExp("(?:(".concat(getAttributePattern("id"), ')="([^"]+)")|(?:(').concat(getAttributePattern("href"), "|").concat(getAttributePattern("role"), "|").concat(getAttributePattern("arcrole"), ')="\\#([^"]+)")|(?:="url\\(\\#([^\\)]+)\\)")|(?:url\\(\\#([^\\)]+)\\))'), "g");
var replaceSvgIds = function(svgText) {
    var svgId = util_randomizeString();
    var getId = function(id) {
        return "".concat(svgId, "__").concat(id);
    };
    return svgText.replace(idPattern, function(m, p1, p2, p3, p4, p5, p6) {
        if (p2) {
            return "".concat(p1, '="').concat(getId(p2), '"');
        }
        if (p4) {
            return "".concat(p3, '="#').concat(getId(p4), '"');
        }
        if (p5) {
            return '="url(#'.concat(getId(p5), ')"');
        }
        if (p6) {
            return "url(#".concat(getId(p6), ")");
        }
    });
};
/* harmony default export */ const util_replaceSvgIds = (replaceSvgIds);

;// CONCATENATED MODULE: ./local_modules/svg-provider/util/getSvgData.ts
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}









var getSvgData = function(html) {
    try {
        var svgText = html.replace(/<\?xml(.*?)\?>/, "");
        var svgTag = svgText.match(/<(svg|symbol)[^>]+>/)[0].replace(/[\n\t]/g, " ");
        var body = svgText.replace("</svg>", "").replace(/<svg[^>]+>/, "").trim();
        body = util_replaceSvgIds(body);
        var attributes = svgTag.match(/\w+=["'][\w\s.]+["']/g).reduce(function(obj, item) {
            var _item_split = _sliced_to_array(item.split("="), 2), key = _item_split[0], value = _item_split[1];
            return _object_spread_props(_object_spread({}, obj), _define_property({}, key.trim(), value.replace(/["']/g, "").trim()));
        }, {});
        return {
            body: body,
            attributes: attributes
        };
    } catch (error) {
        logger/* default */.Z.warn(error);
        return null;
    }
};
/* harmony default export */ const util_getSvgData = (getSvgData);

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__(40963);
;// CONCATENATED MODULE: ./local_modules/svg-provider/util/request.ts




var pendingRequests = {};
var request = function(src) {
    if (!pendingRequests[src]) {
        pendingRequests[src] = new Promise(function(resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.onload = function() {
                if (xhr.status !== 200) {
                    reject("InlineSvg: Request failed: ".concat(src, ", status: ").concat(xhr.status));
                } else if (xhr.response === null) {
                    reject("InlineSvg: Empty response: ".concat(src));
                } else {
                    var svgData = util_getSvgData(xhr.response);
                    resolve(svgData);
                }
                delete pendingRequests[src];
            };
            xhr.onerror = function() {
                reject("InlineSvg: Request failed: ".concat(src));
                delete pendingRequests[src];
            };
            xhr.open("GET", src, true);
            xhr.responseType = "text";
            xhr.send();
        });
    }
    return pendingRequests[src];
};
/* harmony default export */ const util_request = (request);

;// CONCATENATED MODULE: ./local_modules/svg-provider/BrowserRuntime.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function BrowserRuntime_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}










var SVG_NAMESPACE = "http://www.w3.org/2000/svg";
var BrowserRuntime = /*#__PURE__*/ function() {
    "use strict";
    function BrowserRuntime() {
        _class_call_check(this, BrowserRuntime);
        BrowserRuntime_define_property(this, "cache", void 0);
        BrowserRuntime_define_property(this, "spriteElement", void 0);
        this.cache = new Map();
        this.fillCacheFromExistingSprite();
    }
    _create_class(BrowserRuntime, [
        {
            key: "fillCacheFromExistingSprite",
            value: function fillCacheFromExistingSprite() {
                var _this = this;
                var existingSpriteElement = document.getElementById("svg-sprite");
                if (existingSpriteElement) {
                    this.spriteElement = existingSpriteElement;
                    // fill cache with symbols we have in sprite
                    document.querySelectorAll("symbol[data-filename], svg[data-filename]").forEach(function(symbolElement) {
                        var symbolId = symbolElement.id;
                        var fileName = symbolElement.dataset.filename;
                        var raw = symbolElement.outerHTML;
                        _this.loadSvgDataFromSource(fileName, raw, symbolId);
                    });
                } else {
                    this.spriteElement = document.createElementNS(SVG_NAMESPACE, "svg");
                    this.spriteElement.setAttribute("id", "svg-sprite");
                    this.spriteElement.setAttribute("class", "visually-hidden");
                    document.body.prepend(this.spriteElement);
                }
            }
        },
        {
            key: "loadSvgDataFromSource",
            value: function loadSvgDataFromSource(filename, source, symbolId) {
                // because this function can be used only from existing sprite, we don't add the file to sprite
                var svgData = util_getSvgData(source);
                svgData.symbolId = symbolId;
                this.cache.set(filename, svgData);
                return svgData;
            }
        },
        {
            key: "getSvgData",
            value: function getSvgData(filename) {
                return this.cache.get(filename);
            }
        },
        {
            key: "isLoaded",
            value: function isLoaded(filename, symbolId) {
                if (!this.cache.has(filename)) {
                    return false;
                }
                if (symbolId) {
                    return Boolean(document.querySelector('symbol[data-filename="'.concat(filename, '"]')));
                }
                return true;
            }
        },
        {
            key: "loadSvgData",
            value: function loadSvgData(filename, symbolId) {
                var _this = this;
                return _async_to_generator(function() {
                    var svgData, bodyWrapper;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.isLoaded(filename, symbolId)) {
                                    return [
                                        2,
                                        _this.cache.get(filename)
                                    ];
                                }
                                return [
                                    4,
                                    util_request(filename)
                                ];
                            case 1:
                                svgData = _state.sent();
                                svgData.symbolId = symbolId;
                                // if it was added in another promise, we shouldn't add it again
                                if (!_this.isLoaded(filename, symbolId)) {
                                    _this.cache.set(filename, svgData);
                                    if (symbolId) {
                                        bodyWrapper = document.createElementNS(SVG_NAMESPACE, "symbol");
                                        bodyWrapper.innerHTML = svgData.body.trim();
                                        Object.keys(svgData.attributes).forEach(function(key) {
                                            bodyWrapper.setAttribute(key, svgData.attributes[key]);
                                        });
                                        bodyWrapper.setAttribute("id", symbolId);
                                        _this.spriteElement.appendChild(bodyWrapper);
                                    }
                                }
                                return [
                                    2,
                                    svgData
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return BrowserRuntime;
}();
/* harmony default export */ const svg_provider_BrowserRuntime = (BrowserRuntime);


/***/ }),

/***/ 23011:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ svg_provider_Svg)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(35570);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./src/helpers/getters/getGlobalHtmlAttrs.ts
var getGlobalHtmlAttrs = __webpack_require__(6528);
// EXTERNAL MODULE: ./local_modules/svg-provider/SvgProvider.tsx
var SvgProvider = __webpack_require__(99668);
;// CONCATENATED MODULE: ./local_modules/svg-provider/useSvgData.ts
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}


var useSvgData = function(src, source, symbolId) {
    var runtime = (0,SvgProvider/* useSvgProvider */.y)();
    var loadedSrcRef = (0,react.useRef)(null);
    var _useState = _sliced_to_array((0,react.useState)(function() {
        try {
            if (runtime.isLoaded(src, symbolId)) {
                loadedSrcRef.current = src;
                return runtime.getSvgData(src);
            }
            if (source) {
                loadedSrcRef.current = src;
                return runtime.loadSvgDataFromSource(src, source, symbolId);
            }
        } catch (error) {
            console.error(error);
        }
        return null;
    }), 2), svgData = _useState[0], setSvgData = _useState[1];
    (0,react.useEffect)(function() {
        if (loadedSrcRef.current === src) {
            return;
        }
        var isMounted = true;
        if (src) {
            runtime.loadSvgData(src, symbolId).then(function(svgData) {
                if (isMounted) {
                    (0,react.startTransition)(function() {
                        setSvgData(svgData);
                        loadedSrcRef.current = src;
                    });
                }
            })["catch"](function(error) {
                console.error(error);
                if (isMounted) {
                    setSvgData(null);
                }
            });
        }
        return function() {
            isMounted = false;
        };
    }, [
        src,
        symbolId,
        runtime
    ]);
    return svgData;
};
/* harmony default export */ const svg_provider_useSvgData = (useSvgData);

;// CONCATENATED MODULE: ./local_modules/svg-provider/Svg.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






var Svg = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var className = props.className, src = props.src, source = props.source, _props_aspect = props.aspect, aspect = _props_aspect === void 0 ? 1 : _props_aspect, width = props.width, height = props.height, symbolId = props.symbolId, _props_isInline = props.isInline, isInline = _props_isInline === void 0 ? false : _props_isInline, rest = _object_without_properties(props, [
        "className",
        "src",
        "source",
        "aspect",
        "width",
        "height",
        "symbolId",
        "isInline"
    ]);
    var htmlAttrs = (0,getGlobalHtmlAttrs/* default */.Z)(rest);
    var svgData = svg_provider_useSvgData(src, source, isInline ? undefined : symbolId);
    var _ref = svgData || {}, body = _ref.body, attributes = _ref.attributes;
    var defaultAttributes = {
        ref: ref,
        role: "img",
        className: (0,clsx/* default */.Z)("inline-block", className),
        width: width || aspect,
        height: height || 1,
        viewBox: "0 0 ".concat(aspect, " 1")
    };
    if (!isInline) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", _object_spread_props(_object_spread({}, defaultAttributes, attributes, htmlAttrs), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                href: "#".concat(symbolId),
                xlinkHref: "#".concat(symbolId)
            })
        }));
    }
    if (body && attributes) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", _object_spread_props(_object_spread({}, defaultAttributes, attributes, htmlAttrs), {
            "data-filename": src,
            dangerouslySetInnerHTML: {
                __html: body
            }
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", _object_spread({}, defaultAttributes));
});
/* harmony default export */ const svg_provider_Svg = (/*#__PURE__*/react.memo(Svg));


/***/ }),

/***/ 99668:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   y: () => (/* binding */ useSvgProvider)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);


var SvgProviderContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(null);
var SvgProvider = function(param) {
    var children = param.children, value = param.value;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SvgProviderContext.Provider, {
        value: value,
        children: children
    });
};
var useSvgProvider = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(SvgProviderContext);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgProvider);


/***/ }),

/***/ 65163:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73598);
/* harmony import */ var core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_0__);

function debounce(func, wait, immediate) {
    var timeout;
    var result = function result() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var context = this;
        var later = function later() {
            timeout = null;
            if (!immediate) {
                func.apply(context, args);
            }
        };
        var callNow = immediate && timeout === null;
        if (timeout !== null) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(later, wait);
        if (callNow) {
            func.apply(context, args);
        }
    };
    result.cancel = function() {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
    };
    return result;
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (debounce);


/***/ }),

/***/ 57719:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73598);
/* harmony import */ var core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_0__);

function throttle(func, timeout) {
    var isThrottled;
    var context;
    var savedArgs;
    var timeoutId;
    function flush() {
        clearTimeout(timeoutId);
    }
    function wrapper() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (isThrottled) {
            savedArgs = args;
            context = this;
            return;
        }
        func.apply(this, args);
        isThrottled = true;
        timeoutId = setTimeout(function() {
            isThrottled = false;
            if (savedArgs) {
                wrapper.apply(context, savedArgs);
                savedArgs = null;
                context = null;
            }
        }, timeout);
    }
    wrapper.flush = flush;
    return wrapper;
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (throttle);


/***/ }),

/***/ 54490:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var helpers_getters__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96543);
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}

var TrapFocus = function TrapFocus(element) {
    "use strict";
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _this = this;
    _class_call_check(this, TrapFocus);
    _define_property(this, "element", void 0);
    _define_property(this, "options", {
        withInitialFocus: true
    });
    _define_property(this, "mount", function() {
        if (!_this.element) {
            console.error("element was not provided in constructor");
            return;
        }
        var withInitialFocus = _this.options.withInitialFocus, _$element = _this.element;
        var focusableElements = (0,helpers_getters__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_$element);
        var firstFocusableEl = focusableElements[0];
        if (withInitialFocus && firstFocusableEl) {
            firstFocusableEl.focus();
        }
        _$element.addEventListener("keydown", _this.listener);
    });
    _define_property(this, "unmount", function() {
        if (!_this.element) {
            console.error("element was not provided in constructor");
            return;
        }
        _this.element.removeEventListener("keydown", _this.listener);
    });
    _define_property(this, "listener", function(event) {
        var isTabPressed = event.key === "Tab" || event.keyCode === 9;
        if (!isTabPressed) {
            return;
        }
        var focusableElements = (0,helpers_getters__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_this.element);
        var firstFocusableEl = focusableElements[0];
        var lastFocusableEl = focusableElements[focusableElements.length - 1];
        if (event.shiftKey) {
            if (document.activeElement === firstFocusableEl) {
                lastFocusableEl.focus();
                event.preventDefault();
            }
        } else {
            if (document.activeElement === lastFocusableEl) {
                firstFocusableEl.focus();
                event.preventDefault();
            }
        }
    });
    this.element = element;
    this.options = _object_spread({}, this.options, options);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (TrapFocus);


/***/ }),

/***/ 27913:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   GT: () => (/* binding */ useZinaImage),
/* harmony export */   uN: () => (/* binding */ useZinaStaticImage)
/* harmony export */ });
/* unused harmony exports getZinaImage, getPlaceholder */
/* harmony import */ var core_js_modules_es_set_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41964);
/* harmony import */ var core_js_modules_es_set_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5119);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94218);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40045);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51497);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40963);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85183);
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35570);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(59690);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(17376);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8946);
/* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(73281);
/* harmony import */ var core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(52983);
/* harmony import */ var throttle_debounce__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(65163);
/* harmony import */ var config__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(1655);
/* harmony import */ var crypto_helpers__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(45457);
/* harmony import */ var crypto_helpers__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(crypto_helpers__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var logger__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(58738);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(51827);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(50556);
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}



















// ATTN helps to render faster, but can cause high memory consumption in a browser
var cache = new Set();
var preloadImage = function(src) {
    if (cache.has(src)) {
        return Promise.resolve();
    }
    return new Promise(function(resolve, reject) {
        var image = new window.Image();
        image.onload = function() {
            cache.add(src);
            if (image.decode) {
                image.decode().then(resolve)["catch"](reject);
            } else {
                resolve();
            }
        };
        image.onerror = reject;
        image.src = src;
    });
};
var getDeviceResizeValue = function(value) {
    var multiplier = (typeof window !== "undefined" ? window.devicePixelRatio : 1) || 1;
    return Math.ceil(value * multiplier);
};
var getImgProxyUrl = function(props) {
    var src = props.src, bgColor = props.bgColor, quality = props.quality, width = props.width, height = props.height;
    var ext = "";
    var parts = [];
    if (width || height) {
        parts.push("rt:fill", width ? "w:".concat(getDeviceResizeValue(width)) : "h:".concat(getDeviceResizeValue(height)));
    }
    if (quality) {
        parts.push("q:".concat(quality));
    }
    if (bgColor) {
        parts.push("bg:".concat(bgColor.replace("#", "")));
        ext = ".jpg";
    }
    // we serve files from s3 directly
    parts.push((0,crypto_helpers__WEBPACK_IMPORTED_MODULE_13__.encodeBase64)(src.replace("https://cdn.scentbird.com/", "")) + ext);
    var url = "/".concat(parts.join("/"));
    // we use unsigned urls, because we need to do it on the client side and in sync manner
    return "".concat(config__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z.imgproxyUrl, "/_").concat(url);
};
var getZinaImage = function(props) {
    var src = props.src, bgColor = props.bgColor, quality = props.quality, width = props.width, height = props.height, isImgproxyEnabled = props.isImgproxyEnabled;
    if (!src) {
        return src;
    }
    if (isImgproxyEnabled && src.charAt(0) !== "/") {
        return getImgProxyUrl(props);
    }
    var finalSrc = src;
    var params = [];
    if (width || height) {
        params.push(width ? "w=".concat(getDeviceResizeValue(width)) : "h=".concat(getDeviceResizeValue(height)));
    }
    if (quality) {
        params.push("qlty=".concat(quality));
    }
    if (bgColor && src.match(/^http(.*?)\.png$/)) {
        finalSrc = finalSrc.replace(".png", ".jpg");
        params.push("bgcolor=".concat(bgColor.replace("#", "")));
    }
    if (!params.length) {
        return finalSrc;
    }
    return "".concat(finalSrc, "?").concat(params.join("&"));
};
var useIsomorphicEffect =  true ? react__WEBPACK_IMPORTED_MODULE_12__.useLayoutEffect : 0;
var useZinaStaticImage = function(props) {
    var src = props.src, width = props.width, height = props.height, quality = props.quality, bgColor = props.bgColor;
    var isImgproxyEnabled = (0,hooks__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z.abTests.imgproxy) === "b";
    return getZinaImage({
        src: src,
        width: width,
        height: height,
        quality: quality,
        bgColor: bgColor,
        isImgproxyEnabled: isImgproxyEnabled
    });
};
var useZinaImage = function(props) {
    var nodeRef = props.nodeRef, skip = props.skip, _props_preload = props.preload, preload = _props_preload === void 0 ? true : _props_preload, _props_withLoader = props.withLoader, withLoader = _props_withLoader === void 0 ? false : _props_withLoader, src = props.src, bgColor = props.bgColor, aspect = props.aspect, quality = props.quality;
    var isImgproxyEnabled = (0,hooks__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z.abTests.imgproxy) === "b";
    var placeholder = getPlaceholder(aspect);
    var _useState = _sliced_to_array((0,react__WEBPACK_IMPORTED_MODULE_12__.useState)({
        zinaSrc: placeholder,
        originalSrc: null,
        isLoading: withLoader,
        error: null
    }), 2), state = _useState[0], setState = _useState[1];
    useIsomorphicEffect(function() {
        var node = nodeRef === null || nodeRef === void 0 ? void 0 : nodeRef.current;
        if (!node || skip || !src) {
            return;
        }
        var isMounted = true;
        var lastImageId = 0;
        var lastWidth = 0;
        var update = function() {
            if (!isMounted) {
                return;
            }
            var width = node.clientWidth;
            var height = node.clientHeight;
            if (!width && !height) {
                return;
            }
            if (lastWidth >= width) {
                return;
            }
            lastWidth = width;
            var zinaSrc = getZinaImage({
                src: src,
                bgColor: bgColor,
                width: width,
                height: height,
                quality: quality,
                isImgproxyEnabled: isImgproxyEnabled
            });
            var imageId = ++lastImageId;
            if (preload) {
                (0,react__WEBPACK_IMPORTED_MODULE_12__.startTransition)(function() {
                    setState(function(prevState) {
                        return {
                            // keep previous image size or reset it on src change
                            zinaSrc: prevState.originalSrc === src ? prevState.zinaSrc : placeholder,
                            originalSrc: src,
                            isLoading: withLoader,
                            error: null
                        };
                    });
                });
                preloadImage(zinaSrc).then(function() {
                    if (isMounted && imageId === lastImageId) {
                        (0,react__WEBPACK_IMPORTED_MODULE_12__.startTransition)(function() {
                            setState({
                                zinaSrc: zinaSrc,
                                originalSrc: src,
                                isLoading: false,
                                error: null
                            });
                        });
                    }
                })["catch"](function(error) {
                    if (isMounted) {
                        (0,react__WEBPACK_IMPORTED_MODULE_12__.startTransition)(function() {
                            setState({
                                zinaSrc: src,
                                originalSrc: src,
                                isLoading: false,
                                error: error
                            });
                        });
                    }
                });
            } else {
                (0,react__WEBPACK_IMPORTED_MODULE_12__.startTransition)(function() {
                    setState({
                        zinaSrc: zinaSrc,
                        originalSrc: src,
                        isLoading: false,
                        error: null
                    });
                });
            }
        };
        var debouncedUpdate = (0,throttle_debounce__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(function() {
            return update();
        }, 100);
        update();
        // ATTN we do debounced update to fix some issues with carousels
        debouncedUpdate();
        var resizeObserver;
        try {
            if (typeof ResizeObserver !== "undefined") {
                resizeObserver = new ResizeObserver(debouncedUpdate);
                resizeObserver.observe(node);
            }
        } catch (error) {
            logger__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z.warn(error);
        }
        return function() {
            isMounted = false;
            if (resizeObserver) {
                resizeObserver.unobserve(node);
                resizeObserver.disconnect();
                debouncedUpdate.cancel();
            }
        };
    }, [
        nodeRef,
        skip,
        preload,
        src,
        bgColor,
        placeholder,
        quality,
        withLoader,
        isImgproxyEnabled
    ]);
    return state;
};
var getPlaceholder = function() {
    var aspect = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
    return "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 ".concat(aspect, " 1'%3e%3c/svg%3e");
};


/***/ })

}]);